import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=27225b7a&scoped=true&"
import script from "./Preloader.vue?vue&type=script&lang=ts&"
export * from "./Preloader.vue?vue&type=script&lang=ts&"
import style0 from "./Preloader.vue?vue&type=style&index=0&id=27225b7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27225b7a",
  null
  
)

export default component.exports